<template>
  <OrganismsBaseLayout :is-recipe-design="true">
    <slot />
  </OrganismsBaseLayout>
</template>
